import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import invariant from 'invariant';
import lowerCase from 'lodash/lowerCase';
import omit from 'lodash/omit';
import upperFirst from 'lodash/upperFirst';
import { Bridge, joinName } from 'uniforms';

var resolveRef = function resolveRef(reference, schema) {
  invariant(reference.startsWith('#'), 'Reference is not an internal reference, and only such are allowed: "%s"', reference);
  var resolvedReference = reference.split('/').filter(function (part) {
    return part && part !== '#';
  }).reduce(function (definition, next) {
    return definition[next];
  }, schema);
  invariant(resolvedReference, 'Reference not found in schema: "%s"', reference);
  return resolvedReference;
};

var distinctSchema = function distinctSchema(schema) {
  if (schema.type === 'object') {
    return schema;
  }

  if (schema.$ref) {
    return Object.assign(Object.assign({}, schema), resolveRef(schema.$ref, schema));
  }

  return schema;
};

var extractValue = function extractValue() {
  for (var _len = arguments.length, xs = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    xs[_key2] = arguments[_key2];
  }

  return xs.reduce(function (x, y) {
    return x === false || x === null ? '' : x !== true && x !== undefined ? x : y;
  });
};

var pathToName = function pathToName(path) {
  if (path[0] === '.') path = path.replace(/\['(.+?)'\]/g, '.$1').replace(/\[(.+?)\]/g, '.$1').replace(/\\'/g, "'");else path = path.replace(/\//g, '.').replace(/~0/g, '~').replace(/~1/g, '/');
  return path.slice(1);
};

var toHumanLabel = function toHumanLabel(label) {
  return upperFirst(lowerCase(label));
};

var JSONSchemaBridge =
/*#__PURE__*/
function (_Bridge) {
  _inherits(JSONSchemaBridge, _Bridge);

  function JSONSchemaBridge(schema, validator) {
    var _this;

    _classCallCheck(this, JSONSchemaBridge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JSONSchemaBridge).call(this));
    _this.schema = distinctSchema(schema);
    _this._compiledSchema = {};
    _this.validator = validator;
    return _this;
  }

  _createClass(JSONSchemaBridge, [{
    key: "getError",
    value: function getError(name, error) {
      var nameParts = joinName(null, name);
      var rootName = joinName(nameParts.slice(0, -1));
      var baseName = nameParts[nameParts.length - 1];
      return error && error.details && error.details.find && error.details.find(function (detail) {
        var path = pathToName(detail.dataPath);
        return name === path || rootName === path && baseName === detail.params.missingProperty;
      });
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(name, error) {
      var scopedError = this.getError(name, error) || {};
      return scopedError && scopedError.message || '';
    }
  }, {
    key: "getErrorMessages",
    value: function getErrorMessages(error) {
      if (error) {
        if (Array.isArray(error.details)) {
          return error.details.reduce(function (acc, _ref) {
            var message = _ref.message;
            return acc.concat(message);
          }, []);
        }

        return [error.message || error];
      }

      return [];
    }
  }, {
    key: "getField",
    value: function getField(name) {
      var _this2 = this;

      return joinName(null, name).reduce(function (definition, next, nextIndex, array) {
        var previous = joinName(array.slice(0, nextIndex));
        var isRequired = (definition.required || (_this2._compiledSchema[previous] || {}).required || []).includes(next);

        var _key = joinName(previous, next);

        var _definition = _this2._compiledSchema[_key] || {};

        if (next === '$' || next === '' + parseInt(next, 10)) {
          invariant(definition.type === 'array', 'Field not found in schema: "%s"', name);
          definition = Array.isArray(definition.items) ? definition.items[parseInt(next, 10)] : definition.items;
        } else if (definition.type === 'object') {
          invariant(definition.properties, 'Field properties not found in schema: "%s"', name);
          definition = definition.properties[next];
        } else {
          var _filter$map = ['allOf', 'anyOf', 'oneOf'].filter(function (key) {
            return definition[key];
          }).map(function (key) {
            var localDef = definition[key].map(function (subSchema) {
              return subSchema.$ref ? resolveRef(subSchema.$ref, _this2.schema) : subSchema;
            });
            return localDef.find(function (_ref2) {
              var _ref2$properties = _ref2.properties,
                  properties = _ref2$properties === void 0 ? {} : _ref2$properties;
              return properties[next];
            });
          }),
              _filter$map2 = _slicedToArray(_filter$map, 1),
              _filter$map2$ = _filter$map2[0];

          _filter$map2$ = _filter$map2$ === void 0 ? {} : _filter$map2$;
          var _filter$map2$$propert = _filter$map2$.properties,
              combinedDefinition = _filter$map2$$propert === void 0 ? {} : _filter$map2$$propert;
          definition = combinedDefinition[next];
        }

        invariant(definition, 'Field not found in schema: "%s"', name);

        if (definition.$ref) {
          definition = resolveRef(definition.$ref, _this2.schema);
        }

        ['allOf', 'anyOf', 'oneOf'].filter(function (key) {
          return definition[key];
        }).forEach(function (key) {
          _definition[key] = definition[key].map(function (def) {
            return def.$ref ? resolveRef(def.$ref, _this2.schema) : def;
          });
        }); // Naive computation of combined type, properties and required

        if (['allOf', 'anyOf', 'oneOf'].filter(function (key) {
          return definition[key];
        }).length) {
          _definition.type = ([].concat(_definition.allOf, _definition.anyOf, _definition.oneOf).filter(function (def) {
            return def;
          }).find(function (def) {
            return def.type;
          }) || {}).type;

          var _concat$filter$reduce = [].concat(_definition.allOf, _definition.anyOf, _definition.oneOf).filter(function (def) {
            return def;
          }).reduce(function (_ref3, _ref4) {
            var _ref5 = _slicedToArray(_ref3, 2),
                _properties = _ref5[0],
                _required = _ref5[1];

            var properties = _ref4.properties,
                required = _ref4.required;
            return [Object.assign(_properties, properties), _required.concat(required)];
          }, [definition.properties || {}, definition.required || []]),
              _concat$filter$reduce2 = _slicedToArray(_concat$filter$reduce, 2),
              properties = _concat$filter$reduce2[0],
              required = _concat$filter$reduce2[1];

          _definition.properties = properties;
          _definition.required = required;
        }

        _this2._compiledSchema[_key] = Object.assign(_definition, {
          isRequired: isRequired
        });
        return definition;
      }, this.schema);
    }
  }, {
    key: "getInitialValue",
    value: function getInitialValue(name) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _this$getField = this.getField(name),
          _default = _this$getField.default,
          _type = _this$getField.type;

      var _this$_compiledSchema = this._compiledSchema[name],
          _this$_compiledSchema2 = _this$_compiledSchema.default,
          defaultValue = _this$_compiledSchema2 === void 0 ? _default !== undefined ? _default : get(this.schema.default, name) : _this$_compiledSchema2,
          _this$_compiledSchema3 = _this$_compiledSchema.type,
          type = _this$_compiledSchema3 === void 0 ? _type : _this$_compiledSchema3;
      if (defaultValue !== undefined) return cloneDeep(defaultValue);

      if (type === 'array') {
        var item = this.getInitialValue(joinName(name, '0'));
        var items = props.initialCount || 0;
        return Array(items).fill(item);
      }

      if (type === 'object') return {};
      return undefined;
    }
  }, {
    key: "getProps",
    value: function getProps(name) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a = this.getField(name),
          uniforms = _a.uniforms,
          field = __rest(_a, ["uniforms"]);

      var _b = omit(Object.assign(Object.assign(Object.assign({}, field), uniforms), this._compiledSchema[name]), ['default', 'format', 'type']),
          enum_ = _b.enum,
          isRequired = _b.isRequired,
          title = _b.title,
          ready = __rest(_b, ["enum", "isRequired", "title"]);

      if (enum_) ready.allowedValues = enum_;
      if (field.type === 'number') ready.decimal = true;
      if (uniforms && uniforms.type !== undefined) ready.type = uniforms.type;
      if (ready.required === undefined) ready.required = isRequired;
      ready.label = extractValue(ready.label, title, toHumanLabel(joinName(null, name).slice(-1)[0]));
      var options = props.options || ready.options;

      if (options) {
        if (!Array.isArray(options)) {
          ready.transform = function (value) {
            return options[value];
          };

          ready.allowedValues = Object.keys(options);
        } else {
          ready.transform = function (value) {
            return options.find(function (option) {
              return option.value === value;
            }).label;
          };

          ready.allowedValues = options.map(function (option) {
            return option.value;
          });
        }
      }

      return ready;
    }
  }, {
    key: "getSubfields",
    value: function getSubfields(name) {
      if (!name) {
        if (this.schema.properties) {
          return Object.keys(this.schema.properties);
        }

        return [];
      }

      var _this$getField2 = this.getField(name),
          _type = _this$getField2.type,
          _properties = _this$getField2.properties;

      var _this$_compiledSchema4 = this._compiledSchema[name],
          _this$_compiledSchema5 = _this$_compiledSchema4.type,
          fieldType = _this$_compiledSchema5 === void 0 ? _type : _this$_compiledSchema5,
          _this$_compiledSchema6 = _this$_compiledSchema4.properties,
          fieldProperties = _this$_compiledSchema6 === void 0 ? _properties : _this$_compiledSchema6;

      if (fieldType === 'object') {
        return Object.keys(fieldProperties);
      }

      return [];
    }
  }, {
    key: "getType",
    value: function getType(name) {
      var _this$getField3 = this.getField(name),
          _type = _this$getField3.type,
          fieldFormat = _this$getField3.format;

      var _this$_compiledSchema7 = this._compiledSchema[name].type,
          fieldType = _this$_compiledSchema7 === void 0 ? _type : _this$_compiledSchema7;
      if (fieldFormat === 'date-time') return Date;
      if (fieldType === 'string') return String;
      if (fieldType === 'number') return Number;
      if (fieldType === 'integer') return Number;
      if (fieldType === 'object') return Object;
      if (fieldType === 'array') return Array;
      if (fieldType === 'boolean') return Boolean;
      invariant(fieldType !== 'null', 'Field "%s" can not be represented as a type null', name);
      return fieldType;
    }
  }, {
    key: "getValidator",
    value: function getValidator() {
      return this.validator;
    }
  }], [{
    key: "check",
    value: function check() {
      return false;
    }
  }]);

  return JSONSchemaBridge;
}(Bridge);

export { JSONSchemaBridge as default };